import Helpers from '../helpers/util';

class CCBreachForm {
	constructor(el) {
		this.el = el;
		this.openWarningInput = el.querySelector(
			'.cc-breach-form__open-warning'
		);
		this.attachHandlers();
	}

	attachHandlers = () => {
		this.openWarningInput.addEventListener('change', () => {
			Helpers.pubsub.publish('open-lightbox', 'breach-contact');
		});
	};
}

const els = Array.from(document.querySelectorAll('.cc-breach-form'));
els.forEach((el) => {
	new CCBreachForm(el);
});
